import { pmsOperationsResources } from "./pmsOperations";

const rows = `
Invoices|Rechnungen|Faktury
Missing permission: pms.billing.view|Fehlende Berechtigung: pms.billing.view|Brak uprawnienia: pms.billing.view
Missing permission: pms.billing.close|Fehlende Berechtigung: pms.billing.close|Brak uprawnienia: pms.billing.close
Missing permission: pms.billing.void|Fehlende Berechtigung: pms.billing.void|Brak uprawnienia: pms.billing.void
Every invoice issued for {{property}} — number, date, guest, net, tax, gross and status.|Alle Rechnungen für {{property}} — Nummer, Datum, Gast, Netto, Steuer, Brutto und Status.|Wszystkie faktury hotelu {{property}} — numer, data, gość, netto, podatek, brutto i status.
the selected property|das ausgewählte Hotel|wybrany hotel
Back to Billing|Zurück zur Abrechnung|Wróć do rozliczeń
Number or guest|Nummer oder Gast|Numer lub gość
INV-…|INV-…|INV-…
All|Alle|Wszystkie
Settlement|Abrechnung|Rozliczenie
Issued from|Ausgestellt ab|Wystawione od
Issued to|Ausgestellt bis|Wystawione do
Apply filters|Filter anwenden|Zastosuj filtry
Clear|Zurücksetzen|Wyczyść
Invoices: {{value}}|Rechnungen: {{value}}|Faktury: {{value}}
Invoices matching filters: {{value}}|Rechnungen gemäß Filter: {{value}}|Faktury pasujące do filtrów: {{value}}
Invoices in {{currency}}: {{value}}|Rechnungen in {{currency}}: {{value}}|Faktury w {{currency}}: {{value}}
Net {{net}} · Tax {{tax}} · Gross {{gross}}|Netto {{net}} · Steuer {{tax}} · Brutto {{gross}}|Netto {{net}} · podatek {{tax}} · brutto {{gross}}
More invoices exist than are shown. Narrow the filters to see the rest.|Es gibt weitere Rechnungen. Filter eingrenzen, um die übrigen anzuzeigen.|Istnieje więcej faktur niż pokazano. Zawęź filtry, aby zobaczyć pozostałe.
Invoice No.|Rechnungsnr.|Numer faktury
Net|Netto|Netto
Tax|Steuer|Podatek
Gross|Brutto|Brutto
View|Anzeigen|Podgląd
Correct|Korrigieren|Skoryguj
Void|Stornieren|Anuluj
Invoice|Rechnung|Faktura
Credit note|Gutschrift|Korekta
Cancel invoice|Rechnung stornieren|Anuluj fakturę
Close|Schließen|Zamknij
Loading invoice…|Rechnung wird geladen…|Wczytywanie faktury…
Loading invoices…|Rechnungen werden geladen…|Wczytywanie faktur…
No invoice matches these filters.|Keine Rechnung entspricht diesen Filtern.|Żadna faktura nie pasuje do tych filtrów.
This property has no invoices yet.|Dieses Hotel hat noch keine Rechnungen.|Ten hotel nie ma jeszcze faktur.
Invoice date|Rechnungsdatum|Data faktury
Not available|Nicht verfügbar|Niedostępne
Not issued (draft)|Nicht ausgestellt (Entwurf)|Niewystawiona (wersja robocza)
Created by|Erstellt von|Utworzył(a)
Last changed by|Zuletzt geändert von|Ostatnio zmienił(a)
Cancelled by|Storniert von|Anulował(a)
Type|Typ|Typ
Seller|Verkäufer|Sprzedawca
Buyer|Käufer|Nabywca
Corrects invoice|Korrigiert Rechnung|Koryguje fakturę
Cancelled|Storniert|Anulowana
Line|Position|Pozycja
Line {{value}}|Position {{value}}|Pozycja {{value}}
VAT %|MwSt. %|VAT %
VAT|MwSt.|VAT
VAT ID {{value}}|USt-ID {{value}}|NIP {{value}}
No line items stored.|Keine Positionen gespeichert.|Brak zapisanych pozycji.
Total|Gesamt|Suma
PDF|PDF|PDF
Reason|Grund|Powód
Amount to credit (gross, {{currency}})|Gutschriftsbetrag (brutto, {{currency}})|Kwota korekty (brutto, {{currency}})
Why the invoice is corrected|Grund für die Rechnungskorrektur|Dlaczego faktura jest korygowana
Why the invoice is cancelled|Grund für die Rechnungsstornierung|Dlaczego faktura jest anulowana
Working…|Wird ausgeführt…|Przetwarzanie…
Issue|Ausstellen|Wystaw
Create credit note|Gutschrift erstellen|Utwórz korektę
Cancel|Abbrechen|Anuluj
Keep invoice|Rechnung behalten|Zachowaj fakturę
Enter the gross amount to credit.|Bruttobetrag für die Gutschrift eingeben.|Podaj kwotę brutto korekty.
A reason is required.|Ein Grund ist erforderlich.|Podanie powodu jest wymagane.
A {{status}} invoice is not corrected again.|Eine Rechnung mit Status „{{status}}“ wird nicht erneut korrigiert.|Faktura o statusie „{{status}}” nie jest ponownie korygowana.
Invoice {{number}} is already {{status}}.|Rechnung {{number}} hat bereits den Status „{{status}}“.|Faktura {{number}} ma już status „{{status}}”.
Invoice {{number}} has no folio, so no document can be rendered.|Rechnung {{number}} hat kein Gästekonto; das Dokument kann nicht erstellt werden.|Faktura {{number}} nie ma rachunku gościa, więc nie można wygenerować dokumentu.
Credit note {{credit}} created for {{invoice}}.|Gutschrift {{credit}} für {{invoice}} erstellt.|Utworzono korektę {{credit}} do {{invoice}}.
Invoice {{number}} cancelled.|Rechnung {{number}} storniert.|Anulowano fakturę {{number}}.
Invoice {{number}} issued.|Rechnung {{number}} ausgestellt.|Wystawiono fakturę {{number}}.
Room {{number}}|Zimmer {{number}}|Pokój {{number}}
Unknown user|Unbekannter Benutzer|Nieznany użytkownik
Cash|Barzahlung|Gotówka
Card|Karte|Karta
Bank transfer|Überweisung|Przelew bankowy
Voucher|Gutschein|Voucher
`;
const states = `
processed|Processed|Ausgeführt|Zrealizowany
open|Open|Offen|Otwarte
closed|Closed|Geschlossen|Zamknięte
draft|Draft|Entwurf|Wersja robocza
issued|Issued|Ausgestellt|Wystawione
sent|Sent|Versendet|Wysłane
paid|Paid|Bezahlt|Opłacone
unpaid|Unpaid|Unbezahlt|Nieopłacone
partially_paid|Partially paid|Teilbezahlt|Częściowo opłacone
settled|Settled|Abgerechnet|Rozliczone
settlement_pending|Settlement pending|Abrechnung ausstehend|Oczekuje na rozliczenie
cancelled|Cancelled|Storniert|Anulowane
corrected|Corrected|Korrigiert|Skorygowane
failed_compliance|Compliance check failed|Konformitätsprüfung fehlgeschlagen|Błąd kontroli zgodności
failed|Failed|Fehlgeschlagen|Nieudane
fiscalized|Fiscalized|Fiskalisiert|Zafiskalizowane
void|Void|Storniert|Anulowane
voided|Voided|Storniert|Anulowane
posted|Posted|Gebucht|Zaksięgowane
reversed|Reversed|Rückgängig gemacht|Cofnięte
refunded|Refunded|Erstattet|Zwrócone
pending|Pending|Ausstehend|Oczekujące
completed|Completed|Abgeschlossen|Zakończone
requested|Requested|Angefordert|Zlecone
approved|Approved|Genehmigt|Zatwierdzone
rejected|Rejected|Abgelehnt|Odrzucone
locked|Locked|Gesperrt|Zablokowane
archived|Archived|Archiviert|Zarchiwizowane
`;
const types = `
standard|Standard invoice|Standardrechnung|Faktura standardowa
vat|VAT invoice|Umsatzsteuerrechnung|Faktura VAT
proforma|Pro-forma|Proforma|Pro forma
pro_forma|Pro-forma|Proforma|Pro forma
credit_note|Credit note|Gutschrift|Korekta
correction|Correction|Korrektur|Korekta
`;
const entries = [...rows.trim().split("\n").map(row => {const [en, de, pl] = row.split("|");return [en, en, de, pl];}),
  ...[["status", states], ["type", types]].flatMap(([prefix, data]) => data.trim().split("\n").map(row => {const [key, en, de, pl] = row.split("|");return [`${prefix}.${key}`, en, de, pl];}))];
export const pmsInvoiceResources = {
  en: { ...pmsOperationsResources.en, ...Object.fromEntries(entries.map(([key, en]) => [key, en])) },
  de: { ...pmsOperationsResources.de, ...Object.fromEntries(entries.map(([key, , de]) => [key, de])) },
  pl: { ...pmsOperationsResources.pl, ...Object.fromEntries(entries.map(([key, , , pl]) => [key, pl])) },
};
